"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerGroupCollection = void 0;
/**
 * Provides a grouping of layers (layer group) for possible UI purposes, e.g. accordion
 * */
var LayerGroupCollection = /** @class */ (function () {
    function LayerGroupCollection() {
        this.layerGroups = new Array();
        this.useAccordion = false;
        this.expandedOnFirstLoad = false;
        this.alwaysExpandedOnLoad = false;
    }
    return LayerGroupCollection;
}());
exports.LayerGroupCollection = LayerGroupCollection;
//# sourceMappingURL=LayerGroupCollection.js.map